// Fix: aggiorna il prezzo nel widget Trusted Shops al cambio variante
document.addEventListener('variant:update', (event) => {
  const variant = event.detail?.resource;
  if (!variant) return;

  const priceEl = document.querySelector('.price-trusted .price--sale');
  const compareEl = document.querySelector('.price-trusted .price--old');

  if (!priceEl) return;

  const format = (cents) =>
    (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });

  priceEl.textContent = format(variant.price);

  if (compareEl) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl.textContent = format(variant.compare_at_price);
      compareEl.style.display = '';
    } else {
      compareEl.textContent = '';
      compareEl.style.display = 'none';
    }
  }
});
